import { useMutation, useQuery } from '@tanstack/react-query'
import { updateLanguageStatus, listLanguages } from '../api/languages'

export const useUpdateLanguageStatus = () => {
  return useMutation({
    mutationFn: updateLanguageStatus
  })
}

export const useListLanguages = (queryParams = '') => {
  return useQuery({
    queryKey: ['languages', queryParams],
    queryFn: () => listLanguages(queryParams),
  });
};